import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "fileName"]

  openFileDialog() {
    this.fileInputTarget.click()
  }

  fileSelected() {
    const file = this.fileInputTarget.files?.[0]
    this.fileNameTarget.textContent = file ? file.name : "Файл не выбран"
  }
}
